import { RevampTable, TableCell, TableHeader } from '@design/components/table';
import { ReactNode } from 'react';

import styles from './SummaryTable.module.scss';

export interface SummaryTableRow {
  fieldName: string;
  consensus?: ReactNode;
  expected?: ReactNode;
  reported: ReactNode;
  surprise: ReactNode;
  surprisePercent?: ReactNode;
}

export interface SummaryTableProps {
  title: ReactNode;
  tableHeaders: string[];
  tableRows: SummaryTableRow[];
}

export const SummaryTable = ({
  title,
  tableHeaders,
  tableRows,
}: SummaryTableProps) => {
  const renderCell = (key: string, value?: ReactNode) => {
    if (key === 'fieldName') {
      return (
        <TableHeader
          className={styles.styledTableHeader}
          key={key}
          isHoverEnabled={false}
          alignment={'left'}
        >
          <span className={styles.styledRowHeaderLabel}>{value}</span>
        </TableHeader>
      );
    }

    return (
      <TableCell
        className={styles.styledTableCell}
        key={key}
        isNumber
        data-testid={`${key}-cell`}
      >
        {value}
      </TableCell>
    );
  };

  const columnKeys = (
    tableRows.length ? Object.keys(tableRows[0]) : []
  ) as (keyof SummaryTableRow)[];

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{title}</h2>
      <RevampTable className={styles.styledTable} withBodyRowHover={false}>
        <thead>
          <tr>
            {tableHeaders.map((name, idx) => (
              <TableHeader
                className={styles.styledTableHeader}
                key={name}
                isHoverEnabled={false}
                alignment={idx === 0 ? 'left' : 'right'}
              >
                <span>{name}</span>
              </TableHeader>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableRows.map(data => (
            <tr key={data.fieldName}>
              {columnKeys.map(key => renderCell(key, data[key]))}
            </tr>
          ))}
        </tbody>
      </RevampTable>
    </div>
  );
};
